import { BooleanInput, NumberInput, TextInput, minValue, required } from "react-admin";
import { integerValidator } from "utils/validations";
import { CreditsInput, GridItem, HoursInput, InstructionLanguageInput, NationalityInput } from "./Partials";

const ElectiveGroupFields = () => (
  <>
    <GridItem md={6}>
      <TextInput
        source="nameBg"
        label="Име на български"
        fullWidth
        validate={required("Полето е задължително.")}
      />
    </GridItem>
    <GridItem md={6}>
      <TextInput
        source="nameEn"
        label="Име на английски"
        fullWidth
        validate={required("Полето е задължително.")}
      />
    </GridItem>

    <NationalityInput isRequired />
    <InstructionLanguageInput label="Език на преподаване" />

    <CreditsInput />
    <GridItem md={6}>
      <NumberInput
        source="electionCount"
        label="Брой избираеми"
        fullWidth
        min={1}
        step={1}
        validate={[minValue(1, "Минималната стойност е 1."), integerValidator]}
        onWheel={e => e.target.blur()}
      />
    </GridItem>

    <HoursInput
      source="totalHours"
      label="Общо часове"
      md={4}
      isRequired
    />
    <HoursInput
      source="totalLectures"
      label="Общо лекции"
      md={4}
      isRequired
    />
    <HoursInput
      source="totalLabs"
      label="Общо упражнения"
      md={4}
      isRequired
    />

    <GridItem md={4}>
      <BooleanInput
        source="isRequired"
        label="Задължително избираеми"
      />
    </GridItem>
    <GridItem md={4}>
      <BooleanInput
        source="hasScoring"
        label="С оценка"
      />
    </GridItem>
    <GridItem md={4}>
      <BooleanInput
        source="studyInMultipleCourses"
        label="Изучава се в повече от един курс"
      />
    </GridItem>
  </>
);

export default ElectiveGroupFields;
